module.exports = __webpack_public_path__ + "advisory-8c397925/schlusssatz-bewerbung-8505c660210e539788c0d64dfa2bf2a4.jpg";